import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";

export const handleWithdrawApproval = async (id) => {
  const isConfirmed = window.confirm(
    "Are you sure you want to withdraw the approval?"
  );

  if (!isConfirmed) return;

  const idString = (Array.isArray(id) ? id : [id]).join(",");

  try {
    // Perform the update for the certificates (single or multiple)
    await axiosWithToken.post(BASE_URL + "dynamic", {
      query: `UPDATE certificates SET status = 1, approvedBy = NULL, approvedDate = NULL, reviewedBy = NULL, reviewedDate = NULL, signedBy = NULL, signedDate = NULL, rejectedBy = NULL, witnessBy = NULL, witnessDate = NULL WHERE id IN (${idString});`
    });

    toast("Certificate Withdraw successfully!");
    setTimeout(() => window.location.reload(false), 1000);
  } catch (err) {
    console.log("Error: ", err);
  }
};
